<template>
  <div class="page-wrap">
    <div class="header-filter">
      <div class="filter-title">
        <span class="title-text">产品投放查询</span>
      </div>
      <div class="select-wrap">
        <div class="week-wrap">
          <el-date-picker
            v-model="startWeek"
            type="week"
            :format="'yyyy第WW周 (' + startWeekarr[0].substring(5) + '~' + startWeekarr[1].substring(5) + ')'"
            value-format="yyyy-MM-dd"
            placeholder="选择周"
            style="width: 230px"
            :clearable="false"
          >
          </el-date-picker>
          <span style="margin: 4px">至</span>
          <el-date-picker
            v-model="endWeek"
            type="week"
            :format="'yyyy第WW周 (' + endWeekarr[0].substring(5) + '~' + endWeekarr[1].substring(5) + ')'"
            value-format="yyyy-MM-dd"
            placeholder="选择周"
            style="width: 230px; margin-right: 20px"
            :clearable="false"
          >
          </el-date-picker>
        </div>
        <el-select
          class="multiple-select"
          collapse-tags
          v-model="filterData.productId"
          placeholder="全部产品"
          multiple
          filterable
          @change="searchData(true)"
        >
          <el-option v-for="item in productList" :key="item.id" :label="item.appName" :value="item.id"> </el-option>
        </el-select>
        <el-select
          class="multiple-select"
          collapse-tags
          v-model="filterData.principalUser"
          placeholder="全部投放负责人"
          multiple
          @change="searchData(true)"
        >
          <el-option v-for="item in principalNameList" :key="item.id" :label="item.principalName" :value="item.id"> </el-option>
        </el-select>
        <el-select
          class="multiple-select"
          collapse-tags
          v-model="filterData.productStatus"
          placeholder="全部产品状态"
          multiple
          @change="searchData(true)"
        >
          <el-option label="稳定投放" value="稳定投放"> </el-option>
          <el-option label="已暂停" value="已暂停"> </el-option>
          <el-option label="测试中" value="测试中"> </el-option>
          <el-option label="上线待测试" value="上线待测试"> </el-option>
        </el-select>
        <el-select
          class="multiple-select"
          collapse-tags
          v-model="filterData.productPrincipalUser"
          placeholder="全部产品负责人"
          multiple
          @change="searchData(true)"
        >
          <el-option v-for="item in principalUserList" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
        <el-select
          class="multiple-select"
          collapse-tags
          v-model="filterData.productGroupName"
          placeholder="全部项目组"
          multiple
          @change="searchData(true)"
        >
          <el-option v-for="item in productGroupNameList" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
        <el-select
          class="multiple-select"
          collapse-tags
          v-model="filterData.groupName"
          placeholder="全部产品分组"
          multiple
          @change="searchData(true)"
        >
          <el-option v-for="item in groupNameList" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
      </div>
    </div>
    <div class="table-wrap">
      <el-table
        :row-class-name="rowClassName"
        :cell-class-name="cellClassName"
        :data="tableData"
        style="width: 100%"
        height="100%"
        v-loading="loading"
      >
        <el-table-column
          v-for="item of columns"
          :key="item.value"
          :prop="item.value"
          :width="item.width || '200px'"
          :label="item.label"
          :fixed="item.fixed || null"
        >
          <template slot-scope="scope">
            <div v-if="item.value === 'appName'">
              <span :class="[scope.row.status === 4 ? 'red-text' : '']">{{ scope.row[item.value] }}</span>
              <svg-icon @click="showDetailModal(scope.row)" iconClass="detail" className="menu-icon"></svg-icon>
            </div>

            <div v-else-if="item.value === 'chnl'">
              <span :class="['channel-item', item.primary ? 'main' : '']" v-for="item of scope.row[item.value]" :key="item.channel"
                >{{ item.channel }}、</span
              >
            </div>

            <span v-else>{{ scope.row[item.value] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <self-pagination
      class="footer-page"
      :total="pageData.total"
      :pageSize="pageData.size"
      :currentPage="pageData.page"
      ref="tabelPagination"
      @getCurrentPage="changePage"
      @handleSizeChange="changePageSize"
      :hideSiglePage="false"
    ></self-pagination>

    <!-- 详情弹框 -->
    <detail-modal :readOnly="true" ref="detailModalRef"></detail-modal>
  </div>
</template>

<script>
import DetailModal from "../common/detailModal.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import { getPros, getPrincipalName, getTotalReportParams, getProductLog } from "@/api/popuManage.js";
import moment from "moment";
export default {
  name: "ProductQuery",
  components: {
    DetailModal,
    SvgIcon,
  },
  data() {
    return {
      startWeek: null,
      endWeek: null,
      filterData: {
        materialType: -1,
      },
      pageData: {
        total: 12,
        size: 10,
        page: 1,
      },
      //产品状态 1稳定投放 2已暂停 3测试中 4上线待测试
      tableData: [],
      loading: false,
      productList: [],
      principalNameList: [],
      groupNameList: [],
      principalUserList: [],
      productGroupNameList: [],
      columns: [
        { label: "时间", value: "weeks" },
        { label: "市场", value: "market" },
        { label: "产品名称", value: "appName" },
        { label: "投放负责人", value: "principalName" },
        { label: "市场本地化", value: "marketLocal" },
        { label: "游戏本地化", value: "gameLocal" },
        { label: "产品状态", value: "productStatus" },
        { label: "渠道/主要渠道", value: "chnl" },
        { label: "产品方向", value: "productDirection" },
        { label: "回收分析", value: "recoveryAnalysis" },
        { label: "渠道/地区确认", value: "chnlRegion" },
        { label: "调整备注", value: "adjustmentRemarks" },
        { label: "素材迭代组数", value: "resourceNum" },
      ],
    };
  },
  mounted() {
    this.initSelect();
  },
  computed: {
    startWeekarr() {
      let selectDay = moment(this.startWeek);
      return [selectDay.subtract(1, "days").format("YYYY-MM-DD"), selectDay.subtract(-6, "days").format("YYYY-MM-DD")];
    },
    endWeekarr() {
      let selectDay = moment(this.endWeek);
      return [selectDay.subtract(1, "days").format("YYYY-MM-DD"), selectDay.subtract(-6, "days").format("YYYY-MM-DD")];
    },
  },
  watch: {
    startWeekarr() {
      this.searchData(true);
    },
    endWeekarr() {
      this.searchData(true);
    },
  },
  methods: {
    initSelect() {
      //初始化周日期 0周天 6周六
      let day = moment().day();
      this.startWeek = moment()
        .subtract(day - 1 + 7 * 3, "days")
        .format("YYYY-MM-DD");
      this.endWeek = moment()
        .subtract(day - 1, "days")
        .format("YYYY-MM-DD");

      //产品
      getPros({
        order: "asc",
        offset: 0,
        menuName: "materialTestInfoMenu",
      }).then((res) => {
        if (res.code === "0000") {
          this.productList = res.products;
        }
      });
      //投放负责人
      getPrincipalName().then((res) => {
        if (res.code === "0000") {
          this.principalNameList = res.list;
        }
      });
      //产品负责人，项目组，产品分组
      getTotalReportParams().then((res) => {
        if (res.code === "0000") {
          this.groupNameList = res.groupNameList;
          this.principalUserList = res.principalUserList;
          this.productGroupNameList = res.productGroupNameList;
        }
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData(true);
    },
    showDetailModal(row) {
      this.$refs.detailModalRef.showDetailModal(row);
    },
    rowClassName({ row }) {
      if (row.status === 1) {
        return "greenLine";
      } else {
        return "";
      }
    },
    cellClassName({ column, row }) {
      if (column.property === "appName" && (row.status === 3 || row.status === 4)) {
        return "yellowCell";
      } else {
        return "";
      }
    },
    getStatusByText(text) {
      //产品状态 1稳定投放 2已暂停 3测试中 4上线待测试
      switch (text) {
        case "稳定投放":
          return 1;
        case "已暂停":
          return 2;
        case "测试中":
          return 3;
        case "上线待测试":
          return 4;
        default:
          break;
      }
    },
    searchData(resetPage) {
      clearTimeout(this.timer);
      this.loading = true;
      this.timer = setTimeout(() => {
        if (resetPage) {
          this.pageData.page = 1;
        }
        let parmas = {
          pageSize: this.pageData.size,
          pageIndex: this.pageData.page,
          menuName: "materialTestInfoMenu",
          weeksList: [
            this.startWeekarr.map((item) => item.replace(/-/g, "")).join("-"),
            this.endWeekarr.map((item) => item.replace(/-/g, "")).join("-"),
          ].join(),
        };
        for (let [label, value] of Object.entries(this.filterData)) {
          if (value && value.length > 0) {
            parmas[label] = value.join();
          }
        }
        getProductLog(parmas).then((res) => {
          this.loading = false;
          if (res.code === "0000") {
            this.tableData = res.list.map((item) => {
              item.chnl && (item.chnl = JSON.parse(item.chnl));
              //产品状态 1稳定投放 2已暂停 3测试中 4上线待测试
              item.status = this.getStatusByText(item.productStatus);
              return item;
            });
            this.pageData.total = res.num;
          }
        });
      }, 300);
    },
  },
};
</script>

<style lang="less" scoped>
.page-wrap {
  padding: 16px 16px 0px 16px;
  box-sizing: border-box;
  height: calc(100vh - 50px);
  overflow: auto;
  .header-filter {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px 0px 24px;
    .filter-title {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title-text {
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
        font-size: 15px;
      }
    }
    .select-wrap {
      display: flex;
      margin-top: 16px;
      padding-bottom: 16px;
      /deep/ .el-input__icon {
        height: 32px;
      }
      .select-item {
        width: 180px;
        margin: 0px 24px 16px 0px;
      }
      .multiple-select {
        width: 180px;
        margin-right: 24px;
        /deep/ .el-tag.el-tag--info:first-child {
          max-width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .table-wrap {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 24px;
    height: calc(100vh - 290px);
    /deep/ .greenLine {
      background: rgba(32, 175, 55, 0.21);
    }
    /deep/ .yellowCell {
      background: rgba(255, 235, 59, 0.49);
    }
    .channel-item {
      &.main {
        color: rgba(74, 217, 148, 1);
      }
    }
    .red-text {
      color: red;
    }
    .menu-icon {
      cursor: pointer;
      margin-left: 4px;
    }
  }
  .footer-page {
  }
}
</style>
